<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 class="d-inline-block">{{ generatedLinkInfo() ? 'Shareable Link Created!' : 'Create Shareable Link' }}</h3>
    <button type="button" class="btn-close" (click)="dialogRef().close(false)">
      <span class="icon-close"></span>
    </button>
  </div>
</div>
<div class="modal-body mb-10">
  <div class="d-flex flex-column">
    @if (generatedLinkInfo()) {
      <p class="tests-count-label">
        Shareable link was successfully created and will be available until
        <strong>{{ generatedLinkInfo().expireAt | date: 'dd MMMM YYYY HH:mm' }}</strong>
      </p>

      <div class="d-flex flex-column">
        <p class="link-label">Generated Link:</p>
        <a target="_blank" class="link-value" [href]="generatedUrlLinkFull()">{{ generatedUrlLinkFull() }}</a>
      </div>
    } @else {
      <p class="tests-count-label">You have selected {{ shareTestsCount() }} {{ shareTestsCount() === 1 ? 'test' : 'tests' }} to share:</p>
      <div class="test-ids-wrapper">
        <textarea cdkTextareaAutosize cdkAutosizeMinRows="1" class="test-ids-textarea" [value]="shareTestsIdsString()" readonly></textarea>
      </div>
    }
  </div>
</div>
<div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
  <a role="button" class="btn btn-outline-dark" (click)="onCancelClick()">Close</a>

  @if (generatedLinkInfo()) {
    <button type="button" class="btn btn-primary" (click)="onCopyLinkClick()">
      <i class="fa fa-copy"></i>
      Copy Link
    </button>
  } @else {
    <button class="btn btn-primary" [disabled]="loading()" type="submit" (click)="onGenerateLinkClick()">Generate Link</button>
  }
</div>
